import { render, staticRenderFns } from "./StatisticsSalesYear.vue?vue&type=template&id=5490ab0b&scoped=true&"
import script from "./StatisticsSalesYear.vue?vue&type=script&lang=js&"
export * from "./StatisticsSalesYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5490ab0b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5490ab0b')) {
      api.createRecord('5490ab0b', component.options)
    } else {
      api.reload('5490ab0b', component.options)
    }
    module.hot.accept("./StatisticsSalesYear.vue?vue&type=template&id=5490ab0b&scoped=true&", function () {
      api.rerender('5490ab0b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/Dashboard/StatisticsSalesYear.vue"
export default component.exports